module.exports = __webpack_public_path__ + "img/emoji_60.0dde92bb.png";